export default __webpack_public_path__ + "static/media/level.2addfd04.png";